import React, { PureComponent } from 'react';
// Components

interface CardProps {
  className?: string;
  style?: React.CSSProperties;
}
export default class Card extends PureComponent<CardProps> {
  render() {
    const { children, className, style, onClick } = this.props;
    let cl = 'card-look';
    if (className) cl += ' ' + className;
    return (
      <div style={style} className={cl} onClick={onClick}>
        {children}
      </div>
    );
  }
}
